// extracted by mini-css-extract-plugin
module.exports =  {"volume-control":"rqf85o_","volumeControl":"rqf85o_","on":"clbzDIm","off":"O8Z1hMQ"};